// extracted by mini-css-extract-plugin
export default {"title":"Additional-module__title--ERHal","slider":"Additional-module__slider--kgT0t","slide":"Additional-module__slide--OO0Jb","parent":"Additional-module__parent--zPqsF"};